import {env} from '../utils/appMode';
let envFlag = env == 'Test'?1:2;
var gateways = {};
if (envFlag == 2) {
    gateways = {
        baseURL: "https://tpt-apim-cargo-dev.azure-api.net/cc-admin-user-management/v1/",
        profileBaseURL: "https://tpt-apim-cargo-dev.azure-api.net/workFlowAdmin/v1/",
        utilityBaseURL: "https://tpt-apim-cargo-dev.azure-api.net/utilitymanagementadmin/v1/",
        serviceBaseURL: "https://tpt-apim-cargo-dev.azure-api.net/finance-admin/v1/",
        serviceDeliveryBaseURL: "https://tpt-apim-cargo-dev.azure-api.net/service-delivery-admin/v1/",
        workflowtxnAdmin: "https://tpt-apim-cargo-dev.azure-api.net/workflowtxnadmin/v1/",
        invalidTokenPath: "https://tpt-apim-cargo-dev.azure-api.net/cc-admin-user-management/v1/Invalidationoftokens",
        logoutPath: "https://tpt-apim-cargo-dev.azure-api.net/ccLoginAdmin/v1/ccAdminLogout?post_logout_redirect_uri=https://www.dev-cargoconnectadmin.transnetportterminals.net",
        fetchTokenPath: "https://tpt-apim-cargo-dev.azure-api.net/ccLoginAdmin/v1/",
        redirectURIPath: "https://www.dev-cargoconnectadmin.transnetportterminals.net",
    }
}
else if (envFlag == 1) {
    gateways = {
        baseURL: "https://tpt-apim-cargo-test.azure-api.net/cc-admin-user-management/v1/",
        profileBaseURL: "https://tpt-apim-cargo-test.azure-api.net/workFlowAdmin/v1/",
        utilityBaseURL: "https://tpt-apim-cargo-test.azure-api.net/utilitymanagementadmin/v1/",
        serviceBaseURL: "https://tpt-apim-cargo-test.azure-api.net/finance-admin/v1/",
        serviceDeliveryBaseURL: "https://tpt-apim-cargo-test.azure-api.net/service-delivery-admin/v1/",
        workflowtxnAdmin: "https://tpt-apim-cargo-test.azure-api.net/workflowtxnadmin/v1/",
        invalidTokenPath: "https://tpt-apim-cargo-test.azure-api.net/cc-admin-user-management/v1/Invalidationoftokens",
        logoutPath: "https://tpt-apim-cargo-test.azure-api.net/ccLoginAdmin/v1/ccAdminLogout?post_logout_redirect_uri=https://www.test-cargoconnectadmin.transnetportterminals.net",
        fetchTokenPath: "https://tpt-apim-cargo-test.azure-api.net/ccLoginAdmin/v1/",
        redirectURIPath: "https://www.test-cargoconnectadmin.transnetportterminals.net",
    }
}
export const {baseURL,profileBaseURL,utilityBaseURL,serviceDeliveryBaseURL,serviceBaseURL,
    workflowtxnAdmin,invalidTokenPath,logoutPath,fetchTokenPath,redirectURIPath} = gateways;

// working
// export const baseURL = "https://tpt-apim-cargo-dev.azure-api.net/cc-admin-user-management/v1/";
// export const profileBaseURL = "https://tpt-apim-cargo-dev.azure-api.net/workFlowAdmin/v1/";
// export const utilityBaseURL = "https://tpt-apim-cargo-dev.azure-api.net/utilitymanagementadmin/v1/";
// export const serviceBaseUrl = "https://tpt-apim-cargo-dev.azure-api.net/finance-admin/v1/"
// export const workflowtxnAdmin = "https://tpt-apim-cargo-dev.azure-api.net/workflowtxnadmin/v1/";
// export const serviceDeliveryBaseUrl = "https://tpt-apim-cargo-dev.azure-api.net/service-delivery-admin/v1/"
 

// export const baseURL = "https://tpt-apim-cargo-test.azure-api.net/cc-admin-user-management/v1/";
// export const profileBaseURL = "https://tpt-apim-cargo-test.azure-api.net/workFlowAdmin/v1/";
// export const utilityBaseURL = "https://tpt-apim-cargo-test.azure-api.net/utilitymanagementadmin/v1/";
// export const serviceBaseUrl = "https://tpt-apim-cargo-test.azure-api.net/finance-admin/v1/"
// export const workflowtxnAdmin = "https://tpt-apim-cargo-test.azure-api.net/workflowtxnadmin/v1/";
// export const serviceDeliveryBaseUrl = "https://tpt-apim-cargo-test.azure-api.net/service-delivery-admin/v1/"